import React, {useEffect, useState} from 'react';
import IssuingEdgeService from "../../../API/orders/prodaction.issueedge/issueedge/IssuingEdgeService";
import IssuingEdgesTable from "../../../components/UI/table/prodaction/issuingEdges/IssuingEdgesTable";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {constantsErrorMessages} from "../../../Constants";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import {Box} from "@mui/system";
import Typography from "@mui/material/Typography";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {useLocation} from "react-router-dom";
import {calcFilterData} from "../../../utils/common/calcFilterData";
import {IssuingEdgesFilterData} from "../../../data/FilterTables/IssuingEdgesFilterData";

const IssuingEdges = () => {
    const pathname = useLocation().pathname
    const [alertData, setAlertData] = useState({});
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState(data)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, IssuingEdgesFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [IssuingEdgesFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(pathname, "searchQuery", searchQuery)
            }
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        const searchQuery = pagesData[pathname]?.searchQuery

        return {searchQuery, pageSize}
    }
    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        IssuingEdgeService.getAllByOrganizationNotClose().then(function (response) {
            const data = response.data;
            handleSearchQuery(searchQuery, data, pageSize)
            setData(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Выдача производственных материалов"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Выдача производственных материалов
                    </Typography>
                </Box>
                <IssuingEdgesTable
                    data={data}
                    setData={setData}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    handleModalAlert={handleModalAlert}
                    globalFilter={globalFilter}
                    filteredData={filteredData}
                    handleSearchQuery={handleSearchQuery}
                    columnsFilter={columnsFilter}
                />
            </Box>
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};

export default IssuingEdges;